<template>
    <div id="cinput" :class="{
            'full-height': isTextArea}">
        <div v-if="!isTextArea" class="content" :class="{
            active: isFocused, 
            error: error.show, 
            disabled: disabled,
            noLable: !outline}">
            <div class="label" v-if="displayLabel && labelLeft" :style="getLabelStyle">{{title}}<template v-if="doubleDot">:</template></div>
            <div class="input" :class="{'f-grow': !isCheckbox, checkbox: isCheckbox}">
                <input v-if="isInput" :type="type" @focus="inputFocused" @blur="loseFocus" v-model="iValue" @input="updateModel" @change="updateModel" @keyup="keyup" :id="id" ref="val" :disabled="disabled">
                <label v-if="isCheckbox" :for="id" class="icon" :class="{dense: dense}"></label>
                <select v-if="isSelect" v-model="iValue" @change="updateModel" @focus="inputFocused" @blur="loseFocus">
                    <option v-for="(e, i) in options" :key="i" :value="e.value">{{e.label}}</option>
                </select>
            </div>
            <div class="label" v-if="displayLabel && !labelLeft" :style="getLabelStyle">{{title}}</div>
        </div>
        <div v-if="isTextArea" class="content full-height"
            :class="{
            active: isFocused, 
            error: error.show, 
            disabled: disabled}">
            <textarea v-model="iValue" @focus="inputFocused" @blur="loseFocus" @input="updateModel" @change="updateModel"
                :id="id" ref="val" :disabled="disabled">
            </textarea>
        </div>
        <div class="errorMSG" v-if="isErrorSet"><span v-if="error.show">{{error.message}}</span></div>
    </div>
</template>

<script>

export default {
    name: "CInput",
    props: {
        value: {
            required: true,
        },
        options: {
            type: Array,
            required: false,
            default: () => { return [] },
        },
        type: {
            type: String,
            default: 'input',
        },
        title: {
            type: String,

            required: false,
        },
        displayLabel: {
            type: Boolean,
            default: true
        },
        dense: {
            type: Boolean,
            default: false,
        },
        outline: {
            type: Boolean,
            default: true,
        },
        labelWidth: {
            type: String,
            default: 'initial',
        },
        labelLeft: {
            type: Boolean,
            default: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Object,
            default: function () {
                return {
                    show: null,
                    message: '',
                };
            },
        },
        forceFocus: {
            required: false,
            default: false
        },
        doubleDot: {
            required: false,
            default: false,
        }
    },
    data: function(){
        return {
            focused: false,
            iValue: '',
            id: this.makeid(5),
        }
    },
    computed: {
        getLabelStyle() {
            return {width: this.labelWidth};
        },
        isFocused() {
            return this.focused;
        },
        isInput(){
            return this.type !== 'textarea' && this.type !== 'select';
        },
        isSelect(){
            return this.type == 'select';
        },
        isErrorSet() {
            return this.error.show != null;
        },
        isCheckbox(){
            return this.type == 'checkbox';
        },
        isTextArea (){
            return this.type == 'textarea';
        }
    },
    methods:{
        inputFocused(){
            this.focused = true;
        },
        loseFocus (){
            this.focused = false;
        },
        focusField() {
            this.$refs.val.focus();
        },
        keyup(ev){
            if (this.isInput && ev.keyCode === 13) {
                this.$emit('enter');
            }
        },
        updateModel(){
            if(!this.disabled)
                this.$emit('input', this.iValue);   
                this.$emit('change');
        },
        makeid(length) {
            var result           = '';
            var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for ( var i = 0; i < length; i++ ) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        }
    },
    watch: {
        value(){
            this.iValue = this.value;
        },
        forceFocus(){
            if(this.forceFocus)
                this.focusField();
        }
    },
    mounted(){
        this.iValue = this.value;
        if(this.forceFocus) {
            this.focused = true;
            this.focusField();
        }
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    

    .icon {
        font: normal normal normal 14px/1 "Material Design Icons";
    }

    .full-height {
        height:100%!important;
    }

    textarea {
        width:100%;
        margin: 2px;
        outline: none;
    }

    .content {
        @extend %f-row;

        height: $height_default;
        background-color: $sec_bg_color;
        .label {
            color: $font-light-color!important;
        }
    }

    .content.noLable {
        background-color: transparent;
    }

    .content.active {
        background-color: $seltec_color;
        .label {
            color: $font-dark-color!important;
        }
    }

    .content.error {
        background-color: $prim_aleart_color;
        .label {
            color: $font-dark-color!important;
        }
    }

    .errorMSG {
        padding: 2px;
        color: $prim_aleart_color;
        height:16px;
    }

    .disabled {
        opacity: 0.5;
    }

    .input {
        margin:2px;
        padding:2px;
        padding-left:10px;
        background-color: $prim_bg_color;  
        display: flex; 

        input {
            width:100%;
            border: none;
            background-color: transparent;
            outline: none;
            height: 30px;
            color: $font-light-color;
            font-size: 14px;
        } 
        
        select {
            color: $font-light-color;
            outline: none;
            border: none;
            width: 100%;
            background-color: $prim_bg_color;
        }
    }

    .label {
        font-size: 14px;
        display: flex;
        align-items: center;
        padding: 2px;
        padding:0px 10px;
    }

    .checkbox {
        background-color:transparent;
        padding:0px;
        align-items: center;
    }  

    input[type="checkbox"] {
        display:none;
    }
    input[type="checkbox"] + label::before {
        height: 40px;
        width: 40px;
        font-size: 36px;
        background-color: $prim_bg_color;
        display: block;
        content: "";
        float: left;
        margin: -2px;
        border: solid 2px $sec_bg_color;
        box-sizing: border-box;
    }  

    label.dense::before {
        height: 20px!important;
        width: 20px!important;
        font-size: 15px!important;

    }

    input[type="checkbox"]:checked+label::before {
        box-shadow: inset 0px 0px 0px 3px $prim_bg_color;
        color: $seltec_color;
        content: "\F0E1E";
    }

    input[type="checkbox"]:hover + label::before {
        cursor: pointer;
    }

    // label {
    //     padding-top: 7px;
    // }

</style>